<template>
    <div class="main">


        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;">Waybills Reports</h3>

                <div style="display:flex;justify-content:flex-end">
                    <a-button :loading="exportLoading" @click="exportExcell"
                        style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                        icon="export">
                        Export
                    </a-button>
                    <!-- <a-button style="height:31px; border-raduis:5px;margin-right:10px;  background: #418a49; color:#fff;" icon="download">
                    Print Report
                </a-button> -->

                    <!-- <a-range-picker
                :default-value="[moment(startDate, dateFormat), moment(endDate, dateFormat)]"
                style="width: 35%;cursor:pointer"
                :format="dateFormat"
                @change="onChange"
                /> -->

                    <!-- <a-month-picker 
                    class="calender"
                    :default-value="moment(startDate, 'YYYY-MM')"
                    placeholder="Select month" 
                    @change="onChange" 
                /> -->


                </div>
            </div>
            <div>
                <a-table :columns="columns" :loading="tableLoading" :data-source="tableData" :pagination="pagination"
                    class="tableStyle">
                    <span slot="actions" slot-scope="data">
                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">

                                <!-- <a-menu-item>
                                    <a @click="showEditDetails(data)">Edit Product?</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a @click="showUploadImage(data)">Upload Product Image?</a>
                                </a-menu-item> -->
                                <a-menu-item>
                                    <a @click="showMoreDetailsModal(data)">Peview?</a>
                                </a-menu-item>
                                <!-- <a-menu-item>
                                    <a @click="showPriceModal(data)">Set Price?</a>
                                </a-menu-item> -->
                                <!-- <a-menu-item>
                                    <a href="javascript:;">View Product Details</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;">View Inventory Details</a>
                                </a-menu-item> -->
                            </a-menu>
                        </a-dropdown>
                    </span>
                </a-table>
            </div>
        </a-card>
    </div>
</template>



<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import XLSX from "xlsx";

const data = [
    {
        id: 1,
        key: 1,
        brandName: "Product 1",
        categoryName: "Vaccine",
        supplierName: "Mutivet",
        revenue: 4433,
        manufacturerName: "Damsto",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 2,
        key: 2,
        brandName: "Product 2",
        categoryName: "Vaccine 2",
        supplierName: "Mutivet 2",
        revenue: 4433,
        manufacturerName: "Damsto 2",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 3,
        key: 3,
        brandName: "Product 3",
        categoryName: "Vaccine 3",
        supplierName: "Mutivet 3",
        revenue: 4433,
        manufacturerName: "Damsto 3",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    }
]

const columns = [

    {
        title: 'Waybill ID',
        dataIndex: 'id',
        key: "id"
        //  width: 150,
    },
    {
        title: 'Distribution Center',
        dataIndex: 'distributionCentreName',
        key: 'distributionCentreName',
        //  width: 150,
    },

    {
        title: 'Username',
        dataIndex: 'userName',
        key: 'userName',
        //  width: 150,
    },
    {
        title: 'Date Created',
        dataIndex: 'createdAt',
        key: 'createdAt',
        //  width: 150,
    },
    {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        scopedSlots: { customRender: 'actions' },
    }

];

export default {
    name: 'WaybillsReport',
    data() {
        return {
            dateFormat: 'YYYY-MM-DD',
            startDate: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
            endDate: moment().add(1, 'd').format('YYYY-MM-DD'),
            searchText: '',
            data,
            columns,
            product: {},
            tableData: [],
            exportLoading: false,
            pagination: {
                pageSize: 20
            },
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },

            productId: "",
            tableLoading: false,
            rules: {
                productId: [
                    { required: true, message: 'Please choose your product', trigger: 'change' },

                ],
                quantity: [
                    { required: true, message: 'Please enter your quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[1-9]\d*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                sellingPrice: [
                    { required: true, message: 'Please enter selling price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                purchasePrice: [
                    { required: true, message: 'Please enter purchase price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },

        };
    },
    methods: {
        ...mapActions(['getWaybillReport', 'setReportDetailsInfo']),
        moment,
        handleSubmit() {
            // console.log(this.formInline);
        },
        onChange(date) {
            // console.log("date | ", date);
            let month = date.format('M')
            let year = date.format('YYYY')
            this.tableLoading = true;
            this.startDate = moment([year, month - 1]).format(this.dateFormat);
            this.endDate = moment(this.startDate).endOf('month').format(this.dateFormat);
            // console.log("startDate | ", this.startDate);
            // console.log("endDate | ", this.endDate);
            let request_data = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            // console.log("request_data 2 | ", request_data)
            this.loadingInventoryReport(request_data)

        },
        generateKeys() {
            return Math.random().toString(36).slice(2);
        },
        showAddProductPage() {
            this.$router.push('/new-product').catch(() => { });
        },
        showAddStockPage() {
            this.$router.push('/add-stock').catch(() => { });
        },
        showEditDetails(data) {
            this.setCatalogInfo(data);
            this.$router.push('/edit-product').catch(() => { });
        },
        showMoreDetailsModal(data) {
            this.setReportDetailsInfo(data);
            this.$router.push('/waybill-order-report-preview').catch(() => { });
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        exportExcell() {
            this.exportLoading = true
            const dataToExport = [
                [
                    "Distribution Centre Name",
                    "Quantity Ordered",
                    "Total OrderValue",
                ],
            ];

            this.getWaybillReport(this.params).then(response => {

                this.exportLoading = false;

                // console.log('response in sales | ', response)
                if (response.status === 200) {

                    let results = response.data.data;

                    results.forEach((v) => {
                        dataToExport.push([
                            v.distributionCentreName,
                            v.quantityOrdered,
                            v.totalOrderValue,
                        ]);
                    });

                    let wb = XLSX.utils.book_new();
                    let ws = XLSX.utils.aoa_to_sheet(dataToExport);

                    /* Add the worksheet to the workbook */
                    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                    /* generate file and send to client */
                    XLSX.writeFile(wb, `Export-Waybill-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
                    this.exportLoading = false;
                    this.showSuccessAlert("Data Successfully Exported")

                } else {
                    this.exportLoading = false;
                    console.log('Error | ', response)
                }
            },
                error => {
                    this.exportLoading = false;
                    console.log('Error | ', error)
                })
        },
        async loadingWaybillReport(request_data) {

            this.tableLoading = true
            let response = await this.getWaybillReport(request_data)
            if (response.status === 200) {
                this.tableLoading = false
                this.tableData = response.data.data.map(report => ({
                    key: report.id,
                    id: report.id,
                    distributionCentreName: report.distributionCentreName ? report.distributionCentreName : 'N/A',
                    // senderAddress: report.senderAddress ? report.senderAddress : 'N/A',
                    // recepientAddress: report.recepientAddress ? report.recepientAddress : 'N/A',
                    userName: report.userName ? report.userName : 'N/A',
                    createdAt: moment(report.createdAt).format('DD-MM-YYYY'),
                    actions: report
                }))
            } else {
                this.tableLoading = false
                // console.log("Error | ", response)
            }
        }
    },
    created() {
        if (this.loadingWaybillReport) {
            this.loadingWaybillReport(this.params)
        }

    }
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.ant-form-item {
    font-size: 14px;
    height: 38px;
    width: 294px;
    border-radius: 5px;
}

.ant-form-item>>>span {
    text-align: center;
}

.ant-btn {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;

    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 38px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;

}

.ant-btn:hover,
.ant-btn:focus {
    color: #418a49;
    background-color: #fff;
    border-color: #418a49;
}

/* .ant-input:focus,
.ant-input:hover {
    border-color: #418a49;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
} */

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.actionLinks {
    color: #777777;
}

.rightSideinputText {
    width: 100%;
    height: 50px;
    border-radius: 5px;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}


.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.ant-switch-checked {
    background-color: #418a49;
}





.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}



.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.calender>>>.ant-calendar-picker-clear,
.calender>>>.ant-calendar-picker-icon {
    position: absolute;
    top: 37%;
    right: 12px;
    z-index: 1;
    width: 14px;
    height: 14px;
    margin-top: -7px;
    font-size: 12px;
    line-height: 14px;
    transition: all 0.3s;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>